import React from 'react';
export var TagVariant;
(function (TagVariant) {
    TagVariant[TagVariant["Enabled"] = 0] = "Enabled";
    TagVariant[TagVariant["Disabled"] = 1] = "Disabled";
    TagVariant[TagVariant["Success"] = 2] = "Success";
    TagVariant[TagVariant["Warning"] = 3] = "Warning";
    TagVariant[TagVariant["Danger"] = 4] = "Danger";
})(TagVariant || (TagVariant = {}));
export class Tag extends React.Component {
    constructor() {
        super(...arguments);
        this.render = () => {
            let colorStyle = '';
            switch (this.props.variant) {
                case TagVariant.Disabled:
                    colorStyle = 'text-base-100 bg-base-600';
                    break;
                case TagVariant.Success:
                    colorStyle = 'text-green-100 bg-green-700';
                    break;
                case TagVariant.Warning:
                    colorStyle = 'text-yellow-100 bg-yellow-500';
                    break;
                case TagVariant.Danger:
                    colorStyle = 'text-red-100 bg-red-700';
                    break;
                case TagVariant.Enabled:
                default:
                    colorStyle = 'text-primary-100 bg-primary-600';
                    break;
            }
            return (React.createElement(React.Fragment, null,
                React.createElement("span", { className: `${this.props.className} px-2 py-1 text-sm font-semibold leading-tight rounded-full ${colorStyle}`, style: this.props.style }, this.props.label)));
        };
    }
}
